enum TradeInSourceName {
  RightRide = "rightride",
  Kijiji = "kijiji",
  AutoCanadaDealer = "ac-dealer",
}

export default TradeInSourceName;
